import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import mailData from ".././../data/mailData";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import cardData from "../../data/learningcard.json";
import CircularProgress from "@mui/material/CircularProgress";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Modal from "@mui/material/Modal";
import "./LearningCards.css";
import { useMsal } from "@azure/msal-react";
import axios from "axios";

import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import RemoveIcon from '@mui/icons-material/Remove';
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 670,
  bgcolor: "background.paper",
  border: "2px solid #754BFF",
  boxShadow: 24,
  p: "30px",
};
//const baseURL = "http://localhost:3004";
const baseURL = "https://atci.lkm.accenture.com/shell-university-apis";
function LearningCards() {
  const [modalContent, setModalContent] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const Max_Length = 140;
  const [expanded, setExpanded] = useState(false);
  const [openCaseStudy, setOpenCaseStudy] = React.useState(false);
  const handleOpenCaseStudy = () => setOpenCaseStudy(true);
  const handleCloseCaseStudy = () => setOpenCaseStudy(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [CourseData, setCourseData] = useState([]);

  // const [awareCourseData, setAwareCourseData] = useState([]);
  const [EquippedCourseData, setEquippedCourseData] = useState([]);
  const [CompetentCourseData, setCompetentCourseData] = useState([]);

  const [username, setuserName] = useState(null);
  // const handleOpenModal = () => {
  //     setShow(true);
  //   };
  //   const handleCloseModal = () => {
  //     setShow(false);
  //   };
  const handleOpen = (id) => {
    setOpenModal(true);
    const clickedCourseDetail = cardData.filter((obj) => {
      return obj.id === id;
    });
    setModalContent(clickedCourseDetail[0]);
  };

  const handleClose = () => {
    setOpenModal(false);
  };
  let program = "SRE";
  useEffect(() => {
    if (activeAccount) {
      setuserName(activeAccount.username);
      console.log("username is", activeAccount.username);
    } else {
      setuserName(null);
    }
  }, [activeAccount]);
  // useEffect(() => {
  //   console.log("inside fetch");
  //   if (username != null) {
  //     axios
  //       .get(`${baseURL}/fetchsreware/${program}/${username}`, {
  //         headers: {
  //           "Cache-Control": "no-cache",
  //           Accept: "application/json",
  //           Pragma: "no-cache",
  //           Expires: "0",
  //           'Authorization': localStorage.getItem("token"),
  //           'Content-Type': 'application/json'
  //         },
  //       })
  //       .then((res) => {
  //         console.log("datsis0aware", res);
  //         cardData.forEach((val) => {
  //           let completionPercentage = 0;
  //           let tempPercent = 0;
  //           if (val.title == "Aware") {
  //             val.Content.forEach((content1) => {
  //               tempPercent = 0;
  //               content1.courses.forEach((item) => {
  //                 // res.data.includes(item.label) ? (item.percent = 100) : (item.percent = 0);
  //                 if (res.data.includes(item.label)) {
  //                   //  console.log("yesincludes", item.label);
  //                   item.percent = 100;
  //                   tempPercent += item.percent;
  //                 } else {
  //                   item.percent = 0;
  //                 }
  //               });
  //               content1.percent =
  //                 Math.round(tempPercent / content1.courses.length).toFixed(0) +
  //                 "%";
  //               completionPercentage += tempPercent / content1.courses.length;
  //             });

  //             // console.log(completionPercentage);
  //             // val.CompletionPercent = (completionPercentage / val.Content.length).toFixed(0);
  //             val.CompletionPercent = completionPercentage / val.Content.length;
  //           }
  //         });
  //         setAwareCourseData(cardData);

  //         // new cards filter
  //         //   replaceData()
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // }, [username]);
  // useEffect(() => {
  //   console.log("inside fetch");
  //   if (username != null) {
  //     axios
  //       .get(`${baseURL}/fetchsrequipped/${program}/${username}`, {
  //         headers: {
  //           "Cache-Control": "no-cache",
  //           Accept: "application/json",
  //           Pragma: "no-cache",
  //           Expires: "0",
  //           'Authorization': localStorage.getItem("token"),
  //           'Content-Type': 'application/json'
  //         },
  //       })
  //       .then((res) => {
  //         cardData.forEach((val) => {
  //           let completionPercentage = 0;
  //           let tempPercent = 0;
  //           if (val.title == "Equipped") {
  //             val.Content.forEach((content1) => {
  //               tempPercent = 0;
  //               content1.courses.forEach((item) => {
  //                 // res.data.includes(item.label) ? (item.percent = 100) : (item.percent = 0);
  //                 if (res.data.includes(item.label)) {
  //                   //  console.log("yesincludesEquipped", item.label);
  //                   item.percent = 100;
  //                   tempPercent += item.percent;
  //                 } else {
  //                   item.percent = 0;
  //                 }
  //               });
  //               content1.percent =
  //                 Math.round(tempPercent / content1.courses.length).toFixed(0) +
  //                 "%";
  //               completionPercentage += tempPercent / content1.courses.length;
  //             });

  //             // console.log(completionPercentage);
  //             // val.CompletionPercent = (completionPercentage / val.Content.length).toFixed(0);
  //             val.CompletionPercent = completionPercentage / val.Content.length;
  //           }
  //         });
  //         setEquippedCourseData(cardData);

  //         // new cards filter
  //         //   replaceData()
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // }, [username]);
  // useEffect(() => {
  //   console.log("inside fetch");
  //   if (username != null) {
  //     axios
  //       .get(`${baseURL}/fetchsrecompetent/${program}/${username}`, {
  //         headers: {
  //           "Cache-Control": "no-cache",
  //           Accept: "application/json",
  //           Pragma: "no-cache",
  //           Expires: "0",
  //           'Authorization': localStorage.getItem("token"),
  //           'Content-Type': 'application/json'
  //         },
  //       })
  //       .then((res) => {
  //         cardData.forEach((val) => {
  //           let completionPercentage = 0;
  //           let tempPercent = 0;
  //           if (val.title == "Competent") {
  //             val.Content.forEach((content1) => {
  //               tempPercent = 0;
  //               content1.courses.forEach((item) => {
  //                 // res.data.includes(item.label) ? (item.percent = 100) : (item.percent = 0);
  //                 if (res.data.includes(item.label)) {
  //                   //  console.log("yesincludesCompetent", item.label);
  //                   item.percent = 100;
  //                   tempPercent += item.percent;
  //                 } else {
  //                   item.percent = 0;
  //                 }
  //               });
  //               content1.percent =
  //                 Math.round(tempPercent / content1.courses.length).toFixed(0) +
  //                 "%";
  //               completionPercentage += tempPercent / content1.courses.length;
  //             });

  //             // console.log(completionPercentage);
  //             // val.CompletionPercent = (completionPercentage / val.Content.length).toFixed(0);
  //             val.CompletionPercent = completionPercentage / val.Content.length;
  //           }
  //         });
  //         setCompetentCourseData(cardData);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // }, [username]);
  const awareCourseData = cardData.map((item) => item);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary {...props} />
  ))(({ theme }) => ({
    backgroundColor: "#E4E4E4",
    height: "45px !important",
  }));
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#A409FF" : "#308fe8",
    },
  }));
  console.log(awareCourseData);
  return (
    <>
      {/* modal */}
      <Modal
        open={openCaseStudy}
        onClose={handleCloseCaseStudy}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Button
            sx={{
              position: "absolute",
              right: "14px",
              top: "14px",
              padding: "0px 6px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "whiteSmoke",
              border: "2px solid #3498DB",
              borderRadius: "4px",
            }}
            onClick={handleCloseCaseStudy}
            variant="contained"
          >
            X
          </Button>
          <Typography id="modal-modal-description">
            For Case Study details, please contact{" "}
            <a href={`mailto:${mailData.enbridge_talentAcademy_mail}`}>
              {mailData.enbridge_talentAcademy_mail}
            </a>
          </Typography>
        </Box>
      </Modal>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Box className="cardsWrapper">
          <Box className="mb-20">
            <h2>Four Phases of SRE</h2>
            <p className="learningText">
              By providing the essential trainings, we aid in your endeavor to
              develop a prosperous SRE journey. Regardless of your level of
              experience, our trainings will provide you the knowledge,
              abilities, and confidence you need to be successful in your new
              SRE position.
            </p>
          </Box>
          <Grid
            container
            direction={isSmallScreen ? "column" : "row"}
            spacing={2}
          >
            {cardData.map((item, i) => (
              <Grid item xs={3}>
                <Card sx={{ position: "relative" }} tabIndex={0}>
                  {item.title === "Aware" ? (
                    <>
                      <CardMedia
                        component="img"
                        height="120"
                        image={item.image}
                        alt="card-image"
                      />
                      <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
                        <div className="infoText-Wrap">
                          <Box sx={{ color: "white", marginTop: "2px" }}>
                            <h5
                              className="color1"
                              style={{ fontWeight: "600" }}
                            >
                              <span>{item.title}</span>
                            </h5>
                          </Box>
                          <Box className="info-Duration">
                            <Typography
                              sx={{ fontSize: "12px", marginTop: "10px" }}
                            >
                              {item.description.length > Max_Length ? (
                                <div>
                                  {`${item.description.substring(
                                    0,
                                    Max_Length
                                  )}...`}
                                  <span
                                    tabIndex={0}
                                    className="knowmore"
                                    onClick={() => handleOpen(item["id"])}
                                  >
                                    Know More
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  {item.description}
                                  <span
                                    tabIndex={0}
                                    className="knowmore"
                                    onClick={() => handleOpen(item["id"])}
                                  >
                                    Know More
                                  </span>
                                </div>
                              )}
                            </Typography>
                            <Modal
                              hideBackdrop
                              open={openModal}
                              onClose={handleClose}
                              aria-labelledby="child-modal-title"
                              closeAfterTransition
                              aria-describedby="child-modal-description"
                              className="modal-container"
                            >
                              <Box className="model">
                                <div className="model_heading">
                                  <h5 className="paramodel">
                                    {modalContent.title}
                                  </h5>
                                  <span
                                    className="close_btn_model"
                                    onClick={handleClose}
                                  >
                                    Close
                                  </span>
                                </div>
                                <hr />
                                <div className="mainRootWrapper">
                                  <div>
                                    <h6>Description :</h6>
                                    <p>{modalContent["description"]}</p>
                                  </div>
                                  <div>
                                    <h6>
                                      Target Audience :{" "}
                                      <span>
                                        {modalContent["target-audience"]}
                                      </span>
                                    </h6>
                                  </div>
                                  <div>
                                    <h6>Pre-requisite :</h6>
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: modalContent["pre-requisite"],
                                      }}
                                    ></p>
                                  </div>
                                </div>
                              </Box>
                            </Modal>
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-flex",
                              }}
                              className="circleContainer"
                            >
                              <CircularProgress
                                sx={{
                                  height: "65px !important",
                                  width: "65px !important",
                                  zIndex: "1",
                                  color: "#6C4AB6",
                                }}
                                variant="determinate"
                                value={item.CompletionPercent}
                              />
                              <Box
                                sx={{
                                  top: 0,
                                  left: 0,
                                  bottom: 0,
                                  right: 0,
                                  position: "absolute",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "white",
                                  borderRadius: "50%",
                                  height: "65px",
                                  width: "65px",
                                  padding: "2px",
                                  border: "1px solid #6C4AB6",
                                }}
                                className="progressAndDuration"
                              >
                                <Typography
                                  className="innerBorder1"
                                  sx={{
                                    fontSize: "0.55rem",
                                    color: "#6D398F",
                                    textAlign: "center",
                                    fontWeight: "600",
                                  }}
                                  variant="caption"
                                  component="div"
                                  color="text.secondary"
                                >
                                  <span className="completionNum">{`${Math.round(
                                    item.CompletionPercent
                                  )}%`}</span>{" "}
                                  complete
                                </Typography>
                              </Box>
                            </Box>
                            <Box className="durationWrapNew">
                              {item.id === "4" ? (
                                ""
                              ) : (
                                // <img className="weekImage" src={item.duration}></img>
                                // <stack sx={{ position: "absolute" }}><img className="hourGlass" src="images/Selenium/LearningCards/duration-box.png">
                                <stack>
                                  <img
                                    className="hourGlass"
                                    src="images/Hourglass.png"
                                    alt="sand clock icon"
                                  ></img>{" "}
                                  <Typography className="hourText">
                                    <span className="smallText">Duration</span>{" "}
                                    <span className="bottom-color1">
                                      {Math.round(item.hour)} Hours
                                    </span>
                                  </Typography>
                                </stack>
                              )}
                            </Box>
                          </Box>
                        </div>
                      </Stack>
                    </>
                  ) : item.title === "Equipped" ? (
                    <>
                      <CardMedia
                        component="img"
                        height="120"
                        image={item.image}
                        alt="card-image"
                      />
                      <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
                        <div className="infoText-Wrap">
                          <Box sx={{ color: "white", marginTop: "2px" }}>
                            <h5
                              className="color2"
                              style={{ fontWeight: "600" }}
                            >
                              <span>{item.title}</span>
                            </h5>
                          </Box>
                          <Box className="info-Duration">
                            <Typography
                              sx={{ fontSize: "12px", marginTop: "10px" }}
                            >
                              {item.description.length > Max_Length ? (
                                <div>
                                  {`${item.description.substring(
                                    0,
                                    Max_Length
                                  )}...`}
                                  <span
                                    tabIndex={0}
                                    className="knowmore"
                                    onClick={() => handleOpen(item["id"])}
                                  >
                                    Know More
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  {item.description}
                                  <span
                                    tabIndex={0}
                                    className="knowmore"
                                    onClick={() => handleOpen(item["id"])}
                                  >
                                    Know More
                                  </span>
                                </div>
                              )}
                            </Typography>
                            <Modal
                              hideBackdrop
                              open={openModal}
                              onClose={handleClose}
                              aria-labelledby="child-modal-title"
                              closeAfterTransition
                              aria-describedby="child-modal-description"
                              className="modal-container"
                            >
                              <Box className="model">
                                <div className="model_heading">
                                  <h5 className="paramodel">
                                    {modalContent.title}
                                  </h5>
                                  <span
                                    className="close_btn_model"
                                    onClick={handleClose}
                                  >
                                    Close
                                  </span>
                                </div>
                                <hr />
                                <div className="mainRootWrapper">
                                  <div>
                                    <h6>Description :</h6>
                                    <p>{modalContent["description"]}</p>
                                  </div>
                                  <div>
                                    <h6>
                                      Target Audience :{" "}
                                      <span>
                                        {modalContent["target-audience"]}
                                      </span>
                                    </h6>
                                  </div>
                                  <div>
                                    <h6>Pre-requisite :</h6>
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: modalContent["pre-requisite"],
                                      }}
                                    ></p>
                                  </div>
                                </div>
                              </Box>
                            </Modal>
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-flex",
                              }}
                              className="circleContainer"
                            >
                              <CircularProgress
                                sx={{
                                  height: "65px !important",
                                  width: "65px !important",
                                  zIndex: "1",
                                  color: "#754BFF",
                                }}
                                variant="determinate"
                                value={item.CompletionPercent}
                              />
                              <Box
                                sx={{
                                  top: 0,
                                  left: 0,
                                  bottom: 0,
                                  right: 0,
                                  position: "absolute",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "white",
                                  borderRadius: "50%",
                                  height: "65px",
                                  width: "65px",
                                  padding: "2px",
                                  border: "1px solid #754BFF",
                                }}
                                className="progressAndDuration"
                              >
                                <Typography
                                  className="innerBorder2"
                                  sx={{
                                    fontSize: "0.55rem",
                                    color: "#6D398F",
                                    textAlign: "center",
                                    fontWeight: "600",
                                  }}
                                  variant="caption"
                                  component="div"
                                  color="text.secondary"
                                >
                                  <span className="completionNum">{`${Math.round(
                                    item.CompletionPercent
                                  )}%`}</span>{" "}
                                  complete
                                </Typography>
                              </Box>
                            </Box>
                            <Box className="durationWrapNew">
                              {item.id === "4" ? (
                                ""
                              ) : (
                                <stack>
                                  <img
                                    className="hourGlass"
                                    src="images/Hourglass.png"
                                    alt="sand clock icon"
                                  ></img>{" "}
                                  <Typography className="hourText">
                                    <span className="smallText">Duration</span>{" "}
                                    <span className="bottom-color2">
                                      {Math.round(item.hour)} Hours
                                    </span>
                                  </Typography>
                                </stack>
                              )}
                            </Box>
                          </Box>
                        </div>
                      </Stack>
                    </>
                  ) : item.title === "Competent" ? (
                    <>
                      <CardMedia
                        component="img"
                        height="120"
                        image={item.image}
                        alt="card-image"
                      />
                      <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
                        <div className="infoText-Wrap">
                          <Box sx={{ color: "white", marginTop: "2px" }}>
                            <h5
                              className="color3"
                              style={{ fontWeight: "600" }}
                            >
                              <span>{item.title}</span>
                            </h5>
                          </Box>
                          <Box className="info-Duration">
                            <Typography
                              sx={{ fontSize: "12px", marginTop: "10px" }}
                            >
                              {item.description.length > Max_Length ? (
                                <div>
                                  {`${item.description.substring(
                                    0,
                                    Max_Length
                                  )}...`}
                                  <span
                                    tabIndex={0}
                                    className="knowmore"
                                    onClick={() => handleOpen(item["id"])}
                                  >
                                    Know More
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  {item.description}
                                  <span
                                    tabIndex={0}
                                    className="knowmore"
                                    onClick={() => handleOpen(item["id"])}
                                  >
                                    Know More
                                  </span>
                                </div>
                              )}
                            </Typography>
                            <Modal
                              hideBackdrop
                              open={openModal}
                              onClose={handleClose}
                              aria-labelledby="child-modal-title"
                              closeAfterTransition
                              aria-describedby="child-modal-description"
                              className="modal-container"
                            >
                              <Box className="model">
                                <div className="model_heading">
                                  <h5 className="paramodel">
                                    {modalContent.title}
                                  </h5>
                                  <span
                                    className="close_btn_model"
                                    onClick={handleClose}
                                  >
                                    Close
                                  </span>
                                </div>
                                <hr />
                                <div className="mainRootWrapper">
                                  <div>
                                    <h6>Description :</h6>
                                    <p>{modalContent["description"]}</p>
                                  </div>
                                  <div>
                                    <h6>
                                      Target Audience :{" "}
                                      <span>
                                        {modalContent["target-audience"]}
                                      </span>
                                    </h6>
                                  </div>
                                  <div>
                                    <h6>Pre-requisite :</h6>
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: modalContent["pre-requisite"],
                                      }}
                                    ></p>
                                  </div>
                                </div>
                              </Box>
                            </Modal>
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-flex",
                              }}
                              className="circleContainer"
                            >
                              <CircularProgress
                                sx={{
                                  height: "65px !important",
                                  width: "65px !important",
                                  zIndex: "1",
                                  color: "#3653FF",
                                }}
                                variant="determinate"
                                value={item.CompletionPercent}
                              />
                              <Box
                                sx={{
                                  top: 0,
                                  left: 0,
                                  bottom: 0,
                                  right: 0,
                                  position: "absolute",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "white",
                                  borderRadius: "50%",
                                  height: "65px",
                                  width: "65px",
                                  padding: "2px",
                                  border: "1px solid #3653FF",
                                }}
                                className="progressAndDuration"
                              >
                                <Typography
                                  className="innerBorder3"
                                  sx={{
                                    fontSize: "0.55rem",
                                    color: "#6D398F",
                                    textAlign: "center",
                                    fontWeight: "600",
                                  }}
                                  variant="caption"
                                  component="div"
                                  color="text.secondary"
                                >
                                  <span className="completionNum">{`${Math.round(
                                    item.CompletionPercent
                                  )}%`}</span>{" "}
                                  complete
                                </Typography>
                              </Box>
                            </Box>
                            <Box className="durationWrapNew">
                              {item.id === "4" ? (
                                ""
                              ) : (
                                // <img className="weekImage" src={item.duration}></img>
                                <stack>
                                  <img
                                    className="hourGlass"
                                    src="images/Hourglass.png"
                                    alt="sand clock icon"
                                  ></img>{" "}
                                  <Typography className="hourText">
                                    <span className="smallText">Duration</span>{" "}
                                    <span className="bottom-color3">
                                      {Math.round(item.hour)} Hours
                                    </span>
                                  </Typography>
                                </stack>
                              )}
                            </Box>
                          </Box>
                        </div>
                      </Stack>
                    </>
                  ) : (
                    <>
                      <CardMedia
                        component="img"
                        height="120"
                        image={item.image}
                        alt="card-image"
                      />
                      <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
                        <div className="infoText-Wrap">
                          <Box sx={{ color: "white", marginTop: "2px" }}>
                            <h5
                              className="color4"
                              style={{ fontWeight: "600" }}
                            >
                              <span>{item.title}</span>
                            </h5>
                          </Box>
                          <Box className="info-Duration">
                            <Typography
                              sx={{ fontSize: "12px", marginTop: "10px" }}
                            >
                              {item.description.length > Max_Length ? (
                                <div>
                                  {`${item.description.substring(
                                    0,
                                    Max_Length
                                  )}...`}
                                  <span
                                    tabIndex={0}
                                    className="knowmore"
                                    onClick={() => handleOpen(item["id"])}
                                  >
                                    Know More
                                  </span>
                                </div>
                              ) : (
                                <div>
                                  {item.description}
                                  <span
                                    tabIndex={0}
                                    className="knowmore"
                                    onClick={() => handleOpen(item["id"])}
                                  >
                                    Know More
                                  </span>
                                </div>
                              )}
                            </Typography>
                            <Modal
                              hideBackdrop
                              open={openModal}
                              onClose={handleClose}
                              aria-labelledby="child-modal-title"
                              closeAfterTransition
                              aria-describedby="child-modal-description"
                              className="modal-container"
                            >
                              <Box className="model">
                                <div className="model_heading">
                                  <h5 className="paramodel">
                                    {modalContent.title}
                                  </h5>
                                  <span
                                    className="close_btn_model"
                                    onClick={handleClose}
                                  >
                                    Close
                                  </span>
                                </div>
                                <hr />
                                <div className="mainRootWrapper">
                                  <div>
                                    <h6>Description :</h6>
                                    <p>{modalContent["description"]}</p>
                                  </div>
                                  <div>
                                    <h6>
                                      Target Audience :{" "}
                                      <span>
                                        {modalContent["target-audience"]}
                                      </span>
                                    </h6>
                                  </div>
                                  <div>
                                    <h6>Pre-requisite :</h6>
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: modalContent["pre-requisite"],
                                      }}
                                    ></p>
                                  </div>
                                </div>
                              </Box>
                            </Modal>
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-flex",
                              }}
                              className="circleContainer"
                            >
                              <CircularProgress
                                sx={{
                                  height: "65px !important",
                                  width: "65px !important",
                                  zIndex: "1",
                                  color: "#4BAEFD",
                                }}
                                variant="determinate"
                                value={item.CompletionPercent}
                              />
                              <Box
                                sx={{
                                  top: 0,
                                  left: 0,
                                  bottom: 0,
                                  right: 0,
                                  position: "absolute",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "white",
                                  borderRadius: "50%",
                                  height: "65px",
                                  width: "65px",
                                  padding: "2px",
                                  border: "1px solid #4BAEFD",
                                }}
                                className="progressAndDuration"
                              >
                                <Typography
                                  className="innerBorder4"
                                  sx={{
                                    fontSize: "0.55rem",
                                    color: "#6D398F",
                                    textAlign: "center",
                                    fontWeight: "600",
                                  }}
                                  variant="caption"
                                  component="div"
                                  color="text.secondary"
                                >
                                  <span className="completionNum">{`${Math.round(
                                    item.CompletionPercent
                                  )}%`}</span>{" "}
                                  complete
                                </Typography>
                              </Box>
                            </Box>
                            <Box className="durationWrapNew">
                              {item.id === "4" ? (
                                ""
                              ) : (
                                // <img className="weekImage" src={item.duration}></img>
                                <stack>
                                  <img
                                    className="hourGlass"
                                    src="images/Hourglass.png"
                                    alt="sand clock icon"
                                  ></img>{" "}
                                  <Typography className="hourText">
                                    <span className="smallText">Duration</span>{" "}
                                    <span className="bottom-color4">
                                      {Math.round(item.hour)}Hours
                                    </span>
                                  </Typography>
                                </stack>
                              )}
                            </Box>
                          </Box>
                        </div>
                      </Stack>
                    </>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Accordion sx={{ width: "100%", background: "#E4E4E4" }}>
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              fontSize: "1.9rem",
                              border: "solid 1.3px #6D398F",
                              color: "#6D398F",
                            }}
                          />
                        }
                      >
                        <Typography
                          sx={{ color: "#6D398F" }}
                          className="training-type"
                        >
                          Courses
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{ width: "100%" }}
                        className="mainAccDetails"
                      >
                        <Box
                          sx={{
                            width: "100%",
                            background: "white",
                            px: "15px",
                          }}
                        >
                          {item.Content.map((content, i) => (
                            <Stack
                              direction="column"
                              mt={1.5}
                              className="acc-stack"
                              sx={{ overflowY: "auto" }}
                            >
                              {item.Type == "Trainings" ? (
                                <>
                                  <Accordion className="mainAccordion">
                                    <AccordionSummary
                                      sx={{
                                        backgroundColor: "#FFF",
                                        margin: "0px",
                                        padding: "0px",
                                      }}
                                      expandIcon={
                                        <ExpandMoreIcon
                                          sx={{
                                            fontSize: "1rem",
                                            color: "#0041F0",
                                          }}
                                        />
                                      }
                                    >
                                      {/* <ExpansionPanelSummary
                                                                    expandIcon={
                                                                       expanded==true
                                                                            ? <RemoveIcon/>
                                                                            : <AddIcon onClick={handleToggleOne} />
                                                                    }
                                                                >
                                                                </ExpansionPanelSummary> */}
                                      <Stack
                                        direction="row"
                                        sx={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          width: "100%",
                                          padding: "0px",
                                          margin: "0px",
                                        }}
                                        className="courseContent"
                                      >
                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            fontSize: "12px",
                                            padding: "0px",
                                          }}
                                        >
                                          {content.name}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            color: "#A409FF",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {content.percent}
                                        </Typography>
                                      </Stack>
                                    </AccordionSummary>
                                    {content.courses.map((course, i) => (
                                      <AccordionDetails sx={{ width: "100%" }}>
                                        <Stack
                                          direction="row"
                                          spacing={2}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Stack
                                            direction="row"
                                            spacing={1}
                                            sx={{
                                              flex: "4",
                                              display: "flex",
                                              alignItems: "start",
                                            }}
                                          >
                                            <Box>
                                              <img
                                                src="images/SRE/LearningCards/bullet.svg"
                                                className="learning-bullet-icon"
                                                alt="hexagon icon"
                                              ></img>
                                            </Box>
                                            <Button
                                              sx={{
                                                fontSize: "12px",
                                                textTransform: "none",
                                                textAlign: "start",
                                                marginLeft: "0px",
                                              }}
                                              color="primary"
                                              target="_blank"
                                              href={course.link}
                                            >
                                              {course.name}
                                            </Button>
                                          </Stack>
                                          {/* <BorderLinearProgress
                      sx={{ width: "50px", flex: "1" }}
                      variant="determinate"
                      value={course.percent}
                     /> */}
                                        </Stack>
                                      </AccordionDetails>
                                    ))}
                                  </Accordion>
                                </>
                              ) : (
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  sx={{
                                    flex: "4",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: "5px 0px",
                                  }}
                                >
                                  <Box>
                                    <img
                                      src="images/SRE/LearningCards/bullet.svg"
                                      className="learningCasestudy-bullet-icon"
                                      alt="hexagon icon"
                                    ></img>
                                  </Box>
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      cursor: "pointer",
                                    }}
                                    color="primary"
                                    onClick={() =>
                                      window.open(
                                        "https://deepknowledge.accenture.com/enrol/index.php?id=987"
                                      )
                                    }
                                  >
                                    {content}
                                  </Typography>
                                </Stack>
                              )}
                            </Stack>
                          ))}

                          {/* <Box className="durationWrap">
                                                {item.id === "4" ? <img className="weekImage" src={item.duration}></img>
                                                : <stack sx={{position:"absolute"}}><img  className="clockImg" src="images/Selenium/LearningCards/clock.png">
                                               </img> <Typography className="hourText" style={{fontWeight:"bold"}}>{item.hour}</Typography></stack>}
                                                
                                            </Box> */}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default LearningCards;
